module.exports = __webpack_public_path__ + "static/media/Sudan-Map.c748a2eb.svg";